import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../shared/services/authentication.service';

@Component({
  selector: 'eid-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {
  constructor(private authenticationService: AuthenticationService) {}

  ngOnInit(): void {
    this.authenticationService.logout();
  }
}
